import {
  URL_DOMAIN,
  // URL_HELP,
  // URL_DOMAIN_MARKET,
  getJSON,
  // URL_P2,
  requestOptionsPost,
  // requestOptionsPut,
  requestOptionsGet,
} from "./globals";

const getWalletsNameContains = async (fkOrganization, name, page_number, results_per_page, includeInactive = false) => {

  return fetch(
    URL_DOMAIN +
    "wallet/get_wallet_name_contains?keyword=" +
    name +
    "&fk_organization=" + fkOrganization +
    "&page_number=" +
    page_number +
    "&results_per_page=" +
    results_per_page +
    "&include_inactive=" +
    (includeInactive ? 1 : 0),
    requestOptionsGet 
  ).then(getJSON);
};
const getWalletsNameContains2 = async (fkOrganization, name) => {
  return fetch(
    URL_DOMAIN +
      "wallet/get_wallets_by_name?keyword=" +
      name +
      "&fk_organization=" +
      fkOrganization,
    requestOptionsGet
  ).then(getJSON);
};

const getAllWalletInfo = async (
  fkOrganization,
  page_number,
  results_per_page,
  wallet_type,
  walled_id
) => {
  return fetch(
    URL_DOMAIN +
      "wallet/get-all-wallet-info?fk_organization=" +
      fkOrganization +
      "&page_number=" +
      page_number +
      "&results_per_page=" +
      results_per_page +
      "&wallet_type=" +
      wallet_type +
      "&wallet_id=" +
      walled_id,
    requestOptionsGet
  ).then(getJSON);
};

// brings wallet info between two dates
const getAllWalletInfoByDate = async (
  fkOrganization,
  wallet_type,
  walled_id,
  start_date,
  end_date,
) => {
  return fetch(
    URL_DOMAIN +
      "wallet/get_wallet_info_by_date?fk_organization=" +
      fkOrganization +
      "&wallet_type=" +
      wallet_type +
      "&wallet_id=" +
      walled_id +
      "&start_date=" +
      start_date +
      "&end_date=" +
      end_date,
    requestOptionsGet
  ).then(getJSON);
};

const rechargeWallet = async (jsonBody) => {
  requestOptionsPost.body = jsonBody;
  return fetch(URL_DOMAIN + "payin/payin-by-type-web", requestOptionsPost).then(
    getJSON
  );
};

const cancelRecharge = async (jsonBody) => {
  requestOptionsPost.body = jsonBody;
  return fetch(URL_DOMAIN + "payin/cancel_payin_by_type_web", requestOptionsPost).then(
    getJSON
  );
};

const getStatusPayIn = async (id_payin) => {
  // requestOptionsPost.body ;
  return fetch(URL_DOMAIN + "payin/get-status?idempotency_key="+ id_payin, requestOptionsGet).then(
    getJSON
  );
};

const getFeeInfo = async (fkOrganization) => {
  try {
    const response = await fetch(
      URL_DOMAIN +
        "wallet/get-organization-fees?fk_organization=" +
        fkOrganization,
      requestOptionsGet
    );
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json(); 
    
    return data;
  } catch (error) {
    throw error; 
  }
};


export {
  getWalletsNameContains,
  getWalletsNameContains2,
  getAllWalletInfo,
  rechargeWallet,
  getStatusPayIn,
  cancelRecharge,
  getFeeInfo,
  getAllWalletInfoByDate

};
